export const TRACKING_DOMAINS = {
  DESCRIPTION: 'This is a complete list of domains we\'ve detected to be associated with any one of your tracking profile(s)',
};
